import { XCircle, CheckCircle } from "lucide-react"
import SolutionOption from "./SolutionOption"


function normalizeOptions(raw) {
    if (!raw) return []
    if (Array.isArray(raw)) {
        if (raw.length && typeof raw[0] === "object" && raw[0] && "key" in raw[0]) {
            return raw.map(o => ({ key: String(o.key).toLowerCase(), label: (String(o.key).match(/\d+/) || [""])[0], text: o.description || o.text || "" }))
        }
        return raw.map(o => {
            if (o && typeof o === "object") {
                const [k, v] = Object.entries(o)[0] || []
                const text = v && typeof v === "object" ? (v.description || v.text || "") : (v || "")
                return { key: String(k).toLowerCase(), label: (String(k).match(/\d+/) || [""])[0], text: String(text) }
            }
            return { key: "", label: "", text: String(o) }
        })
    }
    if (typeof raw === "object") {
        return Object.entries(raw).map(([k, v]) => {
            const text = v && typeof v === "object" ? (v.description || v.text || "") : (v || "")
            return { key: String(k).toLowerCase(), label: (String(k).match(/\d+/) || [""])[0], text: String(text) }
        })
    }
    try { const parsed = JSON.parse(raw); return normalizeOptions(parsed) } catch { return [] }
}


export default function SubmissionSolution({
    submission,
    meta,
    api,
    t,
    showQuestionOnly = false,
    isAdmin = false,
}) {
    if (!submission) return null

    const canSeeSolution = isAdmin
        ? true
        : meta?.settings?.showSolution === "full" ||
        api.kind === "learner"

    const canSeeQuestion = isAdmin
        ? true
        : showQuestionOnly ||
        meta?.settings?.showSolution === "full" ||
        api.kind === "learner"

    // if (!canSeeSolution && !canSeeQuestion) return null

    return (
        <div className="space-y-4">
            {(submission.answers || []).map((a, i) => {
                const selA = Array.isArray(a.selected)
                    ? a.selected.map(v => String(v).toLowerCase())
                    : a.selected != null ? [String(a.selected).toLowerCase()] : []

                const corr = Array.isArray(a.correct)
                    ? a.correct.map(v => String(v).toLowerCase())
                    : a.correct != null ? [String(a.correct).toLowerCase()] : []

                const opts = normalizeOptions(a.options)

                const correct =
                    JSON.stringify([...selA].sort()) ===
                    JSON.stringify([...corr].sort())
                return (
                    <div
                        key={i}
                        className={`rounded-xl border p-4 ${correct
                            ? "border-green-600/40 bg-green-500/5"
                            : "border-red-600/40 bg-red-500/5"
                            }`}
                    >
                        <div className="flex items-start justify-between gap-3">
                            <div className={t.text}>
                                <div className={`text-xs mb-1 ${t.subtext}`}>
                                    ข้อ {a.no}
                                </div>

                                {canSeeQuestion && (
                                    <div className={`${t.text} leading-relaxed`}>
                                        {a.question}
                                    </div>
                                )}
                            </div>

                            <div className="shrink-0">
                                {correct ? (
                                    <CheckCircle className="size-6 text-green-600" />
                                ) : (
                                    <XCircle className="size-6 text-red-600" />
                                )}
                            </div>
                        </div>

                        {canSeeSolution && (
                            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
                                {opts.map((o, idx) => (
                                    <SolutionOption
                                        key={o.key}
                                        index={idx}
                                        optionKey={o.key}
                                        label={o.label}
                                        text={o.text}
                                        selectedKeys={selA}
                                        correctKeys={corr}
                                        t={t}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
